<template>
    <div>
        <img
            :src="require(`../../../assets/images/want-more@2x.png`)"
            :srcset="`${require(`../../../assets/images/want-more@1x.png`)} 1x, ${require(`../../../assets/images/want-more@2x.png`)} 2x, ${require(`../../../assets/images/want-more@3x.png`)} 3x, ${require(`../../../assets/images/want-more@4x.png`)} 4x`"
        />

        <div class="modal-body">
            <h2>{{ 'Do you need to do more?' | trans }}</h2>
            <p>{{ 'Your monthly Credits have been used up.' | trans }}</p>
            <p>{{ "If you wish to continue crafting amazing images, it's time to get more Credits." | trans }}</p>
        </div>
    </div>
</template>
<script>
import store from '../../../mixins/store.mixin';

export default {
    name: 'CreditExhaustedPro',
    props: {},
    components: {},
    mixins: [store],
    data() {
        return {};
    },
    methods: {},
    computed: {},
};
</script>
